module.exports = __webpack_public_path__ + "static/media/Nicola Casey 5.c538c00d.jpg";